@if (showChrome) {
<ng-container class="gt-app-chrome" [class.has-system-msg]="sysMsgVisible">
  <gtw-header (change-theme)="captureChangeTheme($event)"
              (load-client)="onLoadClient($event)"
              (load-modules)="onLoadModules($event)"
              (logout-user)="onLogout()"
              (load-application)="onLoadApplication($event)"
              (set-taxYearScenario)="onSetTaxYearScenario($event)"
              (set-scenario)="onSetScenario($event)"
              (global-params-changed)="onGlobalParamsChanged()"
              (set-businesses)="onSetBusinesses($event)"
              (sync-businesses)="onSyncBusinesses($event)"
              (set-issue)="onSetIssue($event)"
              [base-urls]="baseURLs"
              [header-data]="headerData"
              [is-dark-theme]="currentTheme">
  </gtw-header>

  <gtw-system-message-popup
    [header-data]="headerData"
    (visibility-change)="onSysMsgVisibilityChange($event)">
  </gtw-system-message-popup>
</ng-container>
}

<div class="gt-body-container">
  @if (showChrome) {
<gtw-navigation
    [base-urls]="baseURLs"
    [channel-key]="channelKey"
    (load-screens)="onLoadScreens($event)"
    (load-current-screen)="onLoadCurrentScreen($event)"
    (load-leftnav)="onLoadLeftNav($event)">
  </gtw-navigation>
}

  <main class="gtw-main-content" [class.gtw-main-content--chromeless]="!showChrome">
    <router-outlet></router-outlet>
  </main>
</div>
